import { render } from "./StatisticalMedicalIncident.vue?vue&type=template&id=32b3d388&scoped=true&ts=true"
import script from "./StatisticalMedicalIncident.vue?vue&type=script&lang=ts"
export * from "./StatisticalMedicalIncident.vue?vue&type=script&lang=ts"

import "./StatisticalMedicalIncident.vue?vue&type=style&index=0&id=32b3d388&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b3d388"]])

export default __exports__